import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBookMedical,
  faUser,
  faMapMarkerAlt,
  faPhoneAlt,
  faClock
} from "@fortawesome/free-solid-svg-icons";
import styles from "./Footer.module.css";
import clinicLogo from "../../static/logo.png";

const Footer = ({ onNavClick }) => {
  // Handle internal section anchor navigation across different routes
  const handleActionClick = (sectionKey) => {
    if (window.location.pathname !== "/") {
      window.location.href = `/#${sectionKey}`;
    } else if (onNavClick && typeof onNavClick === "function") {
      onNavClick(sectionKey);
    }
  };

  return (
    <footer className={styles.footer}>
      <div className={styles.footerInner}>
        {/* ─── 1. MAIN CONTENT AREA (3 Columns on Desktop) ─────────────── */}
        <div className={styles.mainContent}>
          {/* Column 1 (Brand & Mission) */}
          <div className={styles.brandCol}>
            <Link to="/" className={styles.brandLogo}>
              <img
                src={clinicLogo}
                alt="ReformMe Healthcare Clinic Logo"
                className={styles.clinicLogoImg}
              />
              <div className={styles.brandTextStack}>
                <span className={styles.brandTextTop}>ReformMe</span>
                <span className={styles.brandTextBottom}>Healthcare</span>
              </div>
            </Link>
            <p className={styles.brandDesc}>
              Precision physiotherapy and holistic wellness.
              <br />
              Tailored clinical care designed for your complete recovery in Gurugram.
            </p>
          </div>

          {/* Column 2 (Quick Links) */}
          <div className={styles.linksCol}>
            <h3 className={styles.colTitle}>Quick Links</h3>
            <ul className={styles.linksList}>
              <li>
                <a
                  href="/#aboutRef"
                  onClick={(e) => {
                    e.preventDefault();
                    handleActionClick("aboutRef");
                  }}
                  className={styles.linkItem}
                >
                  About the Clinic
                </a>
              </li>
              <li>
                <a
                  href="/#doctorRef"
                  onClick={(e) => {
                    e.preventDefault();
                    handleActionClick("doctorRef");
                  }}
                  className={styles.linkItem}
                >
                  Dr. Monika Sharma
                </a>
              </li>
              <li>
                <Link to="/reviews" className={styles.linkItem}>
                  Patient Reviews
                </Link>
              </li>
              <li>
                <a
                  href="/#blogsRef"
                  onClick={(e) => {
                    e.preventDefault();
                    handleActionClick("blogsRef");
                  }}
                  className={styles.linkItem}
                >
                  Health & Wellness Blog
                </a>
              </li>
            </ul>
          </div>

          {/* Column 3 (Contact & Action) */}
          <div className={styles.contactCol}>
            <h3 className={styles.colTitle}>Visit & Contact</h3>

            <div className={styles.contactList}>
              <div className={styles.contactRow}>
                <FontAwesomeIcon icon={faMapMarkerAlt} className={styles.contactIcon} />
                <span>UGF 207, Suncity Road, Sector 54,<br />Gurugram, Haryana 122011</span>
              </div>
              <div className={styles.contactRow}>
                <FontAwesomeIcon icon={faPhoneAlt} className={styles.contactIcon} />
                <span>+91 9024989935</span>
              </div>
              <div className={styles.contactRow}>
                <FontAwesomeIcon icon={faClock} className={styles.contactIcon} />
                <span>Mon - Sat: 9:00 AM - 8:00 PM<br />Sun: Closed</span>
              </div>
            </div>

            {/* Premium Ghost Button for Portal */}
            <Link to="/login" className={styles.portalButton}>
              <FontAwesomeIcon icon={faUser} />
              <span>Patient Portal Login</span>
            </Link>
          </div>
        </div>

        {/* ─── 2. BOTTOM BAR (Copyright & Legal) ───────────────────────── */}
        <div className={styles.bottomBar}>
          <div>© 2026 ReformMe Healthcare. All rights reserved.</div>
          <div className={styles.legalLinks}>
            <Link to="/privacy" className={styles.legalLink}>
              Privacy Policy
            </Link>
            <Link to="/terms" className={styles.legalLink}>
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
